import { Order, Shipping, User } from '@/types';
import { create } from 'zustand';

export interface AuthState {
    // Данные пользователя
    user: User | null;
    isAuthenticated: boolean;
    orders: Order[] | null;
    shipping: Shipping | null;

    // Действия
    initializeAuth: (user: User | null, shipping: Shipping | null) => void;
    setUser: (user: User | null) => void;
    setShipping: (shipping: Shipping | null) => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
    user: null,
    isAuthenticated: false,
    orders: null,
    shipping: null,

    initializeAuth: (user: User | null, shipping: Shipping | null) => {
        set({
            user,
            isAuthenticated: !!user,
            shipping,
        });
    },

    setUser: (user: User | null) => {
        set({
            user,
            isAuthenticated: !!user,
        });
    },

    setShipping: (shipping: Shipping | null) => {
        set({
            shipping,
        });
    },
}));

export const useAuth = () => {
    const store = useAuthStore();
    return {
        shipping: store.shipping,
        user: store.user,
        isAuthenticated: store.isAuthenticated,
        setUser: store.setUser,
        setShipping: store.setShipping,
        initializeAuth: store.initializeAuth,
    };
};

export default useAuthStore;
